module.exports = __webpack_public_path__ + "assets/img/img334.8cf8868d.png";